import { useSEO, generateLocalBusinessSchema, generateProductSchema, generateWebPageSchema, generateFAQSchema, generateBreadcrumbSchema } from '../../utils/seo';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProductOverview from './components/ProductOverview';
import CustomerBenefits from './components/CustomerBenefits';
import Testimonials from './components/Testimonials';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://greenchoicebag.com';

  // Combined Schema.org JSON-LD
  const combinedSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      generateLocalBusinessSchema(siteUrl),
      generateProductSchema(siteUrl),
      generateWebPageSchema(siteUrl),
      generateFAQSchema(),
      generateBreadcrumbSchema(siteUrl)
    ]
  };

  useSEO({
    title: 'Wholesale Grocery Paper Bags | Green Choice Bag',
    description: 'Green Choice Bag - Premium wholesale eco-friendly paper bags in City of Industry, CA. 100% recycled kraft paper bags with custom printing. FSC certified, competitive pricing, fast shipping nationwide.',
    keywords: 'wholesale paper bags, eco-friendly bags, recycled paper bags, grocery paper bags, bulk paper bags',
    canonical: `${siteUrl}/`,
    ogTitle: 'Wholesale Grocery Paper Bags | Green Choice Bag',
    ogDescription: 'Green Choice Bag - Premium wholesale eco-friendly paper bags in City of Industry, CA. 100% recycled kraft paper bags with custom printing. FSC certified, competitive pricing, fast shipping nationwide.',
    ogImage: `${siteUrl}/og-image.jpg`,
    schema: combinedSchema
  });

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <ProductOverview />
      <CustomerBenefits />
      <Testimonials />
      <CallToAction />
      <Footer />
    </div>
  );
}
